// Third-party browsers known to inject scripts that use eval()
const THIRD_PARTY_BROWSERS = [
  'Snapchat',
  'Instagram',
  'Facebook',
  'Twitter',
  'TikTok',
  'WhatsApp',
  'LinkedIn'
]

// Common third-party CSP violation patterns we can't control
const THIRD_PARTY_URI_PATTERNS = [
  'chrome-extension:',
  'moz-extension:',
  'safari-extension:',
  'data:',
  'blob:',
  'eval:'
]

// Third-party script indicators
const THIRD_PARTY_SCRIPT_PATTERNS = [
  'user-script', // Browser-injected scripts
  'analytics',
  'tracking',
  'ads',
  'gtag',
  'facebook',
  'twitter',
  'instagram'
]

// Determines if a CSP violation should be filtered out (not reported to Sentry)
export const shouldFilterCspViolation = (cspData, userAgent = '') => {
  if (!cspData) return false

  // Filter eval violations from known third-party browsers
  if (cspData.blocked_uri === 'eval' && cspData.violated_directive === 'script-src') {
    // Check if it's from a third-party browser
    const isThirdPartyBrowser = THIRD_PARTY_BROWSERS.some(browser =>
      userAgent.includes(browser)
    )

    // Check if it's from a known third-party script pattern
    const documentUri = cspData.document_uri || ''
    const sourceFile = cspData.source_file || ''
    const isThirdPartyScript = THIRD_PARTY_SCRIPT_PATTERNS.some(pattern =>
      sourceFile.includes(pattern) || documentUri.includes(pattern)
    )

    if (isThirdPartyBrowser || isThirdPartyScript) {
      return true
    }
  }

  // Filter other common third-party violations
  const blockedUri = cspData.blocked_uri || ''
  if (THIRD_PARTY_URI_PATTERNS.some(pattern => blockedUri.includes(pattern))) {
    return true
  }

  return false
}

// Logs filtered CSP violations
export const logFilteredCspViolation = (cspData, userAgent, reason = 'third-party') => {
  const logData = {
    reason,
    browser: userAgent,
    sourceFile: cspData?.source_file,
    blockedUri: cspData?.blocked_uri,
    violatedDirective: cspData?.violated_directive
  }

  console.log('Filtered CSP violation from third-party source:', logData)
}

export default {
  shouldFilterCspViolation,
  logFilteredCspViolation
}
